import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { Problem } from "./components/Problem";
import { Solution } from "./components/Solution";
import { Channels } from "./components/Channels";
import { ConversationExamples } from "./components/ConversationExamples";
import { Steps } from "./components/Steps";
import { Outcome } from "./components/Outcome";
import { Audience } from "./components/Audience";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { ContactForm } from "./components/ContactForm";
import { Footer } from "./components/Footer";
export default function App() {
  return (
    <div
      className="grain-overlay min-h-screen"
      style={{
        background: `
          radial-gradient(ellipse 80% 50% at 20% -10%, var(--glow-purple) 0%, transparent 60%),
          radial-gradient(ellipse 60% 40% at 80% 110%, var(--glow-gold) 0%, transparent 55%),
          var(--background)
        `,
      }}
    >
      <Navigation />
      <Hero />
      <Problem />
      <Solution />
      <Channels />
      <ConversationExamples />
      <Steps />
      <Outcome />
      <Audience />
      <Faq />
      <FinalCta />
      <ContactForm />
      <Footer />
    </div>
  );
}